<!--  -->
<template>
    <div class="g-pager" v-if="!hideIfOnePage && totalPage>0">
        <span @click="changePage(currentPage-1)" class="g-pager-item g-pager-nav" :class="{disabled:currentPage===1}">
            <g-icon icon="left"></g-icon>
        </span>
        <template v-for="(item,index) in pages">
            <span class="g-pager-item current" v-if="item === currentPage" :key="index">{{item}}</span>
            <g-icon
                icon="dots"
                class="g-pager-item dot"
                v-else-if="item === '...'"
                :key="index"
            >{{item}}</g-icon>
            <span class="g-pager-item other" @click="changePage(item)" v-else :key="index">{{item}}</span>
        </template>
        <span @click="changePage(currentPage+1)" class="g-pager-item g-pager-nav" :class="{disabled:currentPage===totalPage}">
            <g-icon icon="right"></g-icon>
        </span>
    </div>
</template>

<script>
import GIcon from './icon'
export default {
    name: 'pager',
    components: {
        GIcon
    },
    props: {
        totalPage: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        hideIfOnePage: {
            type: Boolean,
            default: false
        }
    },
    computed:{
        pages() {
            const list = [
                1,
                this.currentPage - 1,
                this.currentPage - 2,
                this.currentPage,
                this.currentPage + 1,
                this.currentPage + 2,
                this.totalPage
            ].filter(item => item >= 1 && item <= this.totalPage)
            const arr = list.sort((a, b) => a - b)
            return this.addPoint(this.unique(arr))
        }
    },
    methods: {
        unique(arr) {
            let obj = {}
            arr.forEach(item => {
                obj[item] = item
            })
            return Object.values(obj)
        },
        addPoint(arr) {
            return arr.reduce((pre, current, index) => {
                pre.push(current)
                arr[index + 1] &&
                    arr[index + 1] - arr[index] > 1 &&
                    pre.push('...')
                return pre
            }, [])
        },
        changePage(n) {
            if(n<1 || n>this.totalPage){return}
            this.$emit('update:currentPage', n)
            this.$emit('size-change',n)
        }
    }
}
</script>
<style scoped lang='scss'>
@import 'var';
.g-pager {
    display: flex;
    align-items: center;
    user-select: none;
    &-item {
        border: 1px solid #e1e1e1;
        border-radius: $border-radius;
        padding: 0 4px;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-size: 12px;
        min-width: 20px;
        height: 20px;
        margin: 0 4px;
        &.current {
            color: #fff;
            background-color: $blue;
            border-color: $blue;
            cursor: default;
        }
        &.dot {
            cursor: default;
            border: none;
        }
        &.other {
            &:hover {
                color: $blue;
            }
        }
    }
    &-nav {
        background: $grey;
        border-color: $grey;
        &.disabled {
            cursor: default;
            svg {
                fill: darken($grey, 30%);
            }
        }
    }
}
</style>